<template>
    <section>
        <v-dialog v-model="dialogUpdateAccount" width="450px" persistent transition="dialog-bottom-transition">
            <v-card class="card-outline custom-color-dialog">
                <v-card-title class="headline headline_bg">
                    <h5>Account update</h5>
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <fieldset>
                                <!-- <legend class="w-auto card_legend">Account information</legend> -->
                                <v-row no-gutters class="pt-6">
                                    <v-col cols="12" class="px-2">
                                        <v-text-field class="regular-field" v-model="accountForm.mobilenumber" label="Mobile number" :error-messages="formerror.mobilenumber"></v-text-field>
                                    </v-col>
                                    <!-- <v-col cols="12" class="px-2">
                                        <v-text-field class="regular-field" v-model="accountForm.playerlink" :label="player_link" :error-messages="formerror.playerlink" :disabled="accountForm.playerlink ? true:false"></v-text-field>
                                    </v-col> -->
                                    <v-col cols="12" class="px-2">
                                        <v-checkbox hide-details dense v-model="accountForm.changepassword" label="Change password" @change="clickchangepass"></v-checkbox>
                                    </v-col>
                                </v-row>
                            </fieldset>
                        </v-col>
                        
                        <v-col cols="12" lg="12" class="mb-n5 pt-0 mt-0 account-settings-fields" v-if="accountForm.changepassword == true">
                            <fieldset>
                                <v-row no-gutters>
                                    <v-col cols="12" class="px-2">
                                        <v-text-field class="regular-field" v-model="accountForm.current_password" label="Current password" :error-messages="formerror.current_password" :append-icon="val_current_password ? 'mdi-eye-off-outline' : 'mdi-eye-outline'" @click:append="() => (val_current_password = !val_current_password)" :type="val_current_password ? 'password' : 'text'"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" class="px-2">
                                        <v-text-field class="regular-field" v-model="accountForm.new_password" label="New password" :error-messages="formerror.new_password" :append-icon="val_new_password ? 'mdi-eye-off-outline' : 'mdi-eye-outline'" @click:append="() => (val_new_password = !val_new_password)" :type="val_new_password ? 'password' : 'text'"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" class="px-2">
                                        <v-text-field class="regular-field" v-model="accountForm.repeat_password" label="Repeat Password" :error-messages="formerror.repeat_password" :append-icon="val_repeat_password ? 'mdi-eye-off-outline' : 'mdi-eye-outline'" @click:append="() => (val_repeat_password = !val_repeat_password)" :type="val_repeat_password ? 'password' : 'text'"></v-text-field>
                                    </v-col>
                                </v-row>
                            </fieldset>
                        </v-col>

                    </v-row>
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions class="actionButtons">
                    <v-row no-gutters>
                        <v-col cols="6" lg="6" md="6" sm="6" class="px-2">
                            <v-btn color="error" @click="dialogUpdateAccount = false">Close</v-btn>
                        </v-col>
                        <v-col cols="6" lg="6" md="6" sm="6" class="px-2">
                            <v-btn color="info" class="float-right" @click="updateAccount">Update</v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </section>
</template>

<script>
    export default {
        data(){
            return{
                val_current_password: String,
                val_new_password: String,
                val_repeat_password: String,
                dialogUpdateAccount: false,
                formerror: {},
                accountForm: new this.$Form({
                    id: '',
                    name: '',
                    username: '',
                    email: '',
                    current_password: '',
                    new_password: '',
                    repeat_password: '',
                    changepassword: false,
                    mobilenumber: '',
                    playerlink: '',
                }),
                player_link: "Player link",
            };
        },
        methods:{
            clickchangepass(){
                this.accountForm.current_password = "";
                this.accountForm.new_password = "";
                this.accountForm.repeat_password = "";
            },
            modalUpdateAccount(){
                this.formerror = {};
                this.accountForm.reset();
                this.$axios.get(this.$_CONFIG.api() + "/agentportal/agentdata").then((data) => {
                    this.accountForm.fill(data.data.user);
                    if(data.data.user.agent_data.playerid_link){
                        this.player_link = "Player linked to " + data.data.user.agent_data.player_link.username;
                        this.accountForm.playerlink = data.data.user.agent_data.playerid_link;
                    }
                    this.dialogUpdateAccount = true;
                }).catch(() => {
                    this.$toast.fire({ icon: 'error', title: "Something went wrong!" });
                });
            },
            updateAccount(){
                this.accountForm.iseditaccountinfo = true;
                this.accountForm
                .post(this.$_CONFIG.api() + "/agentportal/agentupdatedata")
                .then(({ data }) => {
                    this.dialogUpdateAccount = false;
                    this.$toast.fire({ icon: 'success', title: "Account successfully updated." });
                })
                .catch((error) => {
                    if (error.response.data.errors != undefined) {
                        this.formerror = error.response.data.errors;
                    }

                    if (error.response.data.message != undefined) {
                        this.$toast.fire({ icon: "error", title: error.response.data.message });
                    }
                });
            },
        },
        computed: {

        },
        created(){
            this.$Fire.$on("editUserAccount", (data) => {
              this.modalUpdateAccount();
            });
        },
        mounted() {
        }
    }
</script>
